import { render } from "./HeaderView.vue?vue&type=template&id=327a0bf5&scoped=true"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import "../../../assets/css/Main/Layout/HeaderView.css?vue&type=style&index=0&id=327a0bf5&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327a0bf5"]])

export default __exports__